/**
 * Fiscal constants for 2026.
 * Update yearly — see docs/TAX_UPDATES.md for the checklist.
 *
 * Sources:
 *  - Social Security: Orden PJC/297/2026, BOE 31-mar-2026.
 *  - IRPF estatal: art. 63.1 LIRPF.
 *  - IRPF Valencia: escala autonómica vigente Comunidad Valenciana
 *    (pending reform legislated 1-Jan-2026, awaiting Les Corts approval).
 *  - Mínimos: arts. 57–61 LIRPF.
 *  - Reducción conjunta: art. 84 LIRPF.
 */

// Social Security
export const SS_RATE = 0.305;
export const SS_COLLAB_FLOOR_BASE = 1424.6;

// [upper monthly net income, monthly minimum base]. First 3 rows are reduced brackets.
export const SS_TRAMOS = [
  [670, 653.59],
  [900, 718.95],
  [1166.7, 849.67],
  [1300, 950.98],
  [1500, 960.78],
  [1700, 960.78],
  [1850, 1143.79],
  [2030, 1209.15],
  [2330, 1274.51],
  [2760, 1356.21],
  [3190, 1437.91],
  [3620, 1519.61],
  [4050, 1601.31],
  [6000, 1732.03],
  [Infinity, 1928.1],
];

// IRPF
// [upper taxable base, marginal rate]
export const STATE_SCALE = [
  [12450, 0.095],
  [20200, 0.12],
  [35200, 0.15],
  [60000, 0.185],
  [300000, 0.225],
  [Infinity, 0.245],
];

// Comunidad Valenciana autonomic scale (in force).
export const CV_SCALE = [
  [12000, 0.09],
  [22000, 0.12],
  [32000, 0.15],
  [42000, 0.175],
  [52000, 0.2],
  [65000, 0.225],
  [72000, 0.245],
  [100000, 0.25],
  [150000, 0.265],
  [200000, 0.275],
  [Infinity, 0.295],
];

export const MIN_PERSONAL = 5550;
// Cumulative mínimo por descendientes for 0..4 kids.
export const CHILD_MIN = [0, 2400, 5100, 9100, 13600];
// Valencia augments autonomic minimo by 10%.
export const CV_MIN_FACTOR = 1.1;
export const JOINT_REDUCTION = 3400;
export const WORK_OTHER_EXPENSES = 2000;
export const DJ_RATE = 0.07;
export const DJ_CAP = 2000;
export const FLAT_RATE_MONTH = 80;
